import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ArrowRightAltRoundedIcon from "@mui/icons-material/ArrowRightAltRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import LottieShowcase from "./LottieShowcase";
import { heroStats, lottieSources } from "./landingContent";

export default function Hero() {
  return (
    <Box
      id="hero"
      sx={{ width: "100%", pt: { xs: 12, sm: 14 }, pb: { xs: 8, sm: 10 } }}
    >
      <Container maxWidth="lg">
        <Box
          sx={(theme) => ({
            position: "relative",
            overflow: "hidden",
            border:
              theme.palette.mode === "dark"
                ? "1px solid rgba(90, 142, 194, 0.42)"
                : "1px solid rgba(88, 196, 255, 0.38)",
            borderRadius: { xs: 4, md: 6 },
            bgcolor: theme.palette.mode === "dark" ? "#091523" : "#041225",
            p: { xs: 3, sm: 4, md: 5 },
          })}
        >
          <Box
            sx={(theme) => ({
              position: "absolute",
              inset: 0,
              background:
                theme.palette.mode === "dark"
                  ? "radial-gradient(circle at 16% 18%, rgba(48,128,184,0.26), rgba(9,21,35,0) 46%), radial-gradient(circle at 84% 12%, rgba(74,146,207,0.2), rgba(9,21,35,0) 42%)"
                  : "radial-gradient(circle at 16% 18%, rgba(65,178,255,0.24), rgba(4,18,37,0) 46%), radial-gradient(circle at 84% 12%, rgba(99,193,255,0.2), rgba(4,18,37,0) 42%)",
            })}
          />
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              opacity: 0.24,
              backgroundImage:
                "linear-gradient(rgba(124,232,255,0.15) 1px, transparent 1px), linear-gradient(90deg, rgba(124,232,255,0.15) 1px, transparent 1px)",
              backgroundSize: "40px 40px",
              maskImage:
                "radial-gradient(circle at 45% 36%, black 18%, transparent 80%)",
              WebkitMaskImage:
                "radial-gradient(circle at 45% 36%, black 18%, transparent 80%)",
            }}
          />

          <Grid
            container
            spacing={{ xs: 4, md: 5 }}
            alignItems="center"
            sx={{ position: "relative" }}
          >
            <Grid item xs={12} lg={6}>
              <Stack spacing={3}>
                <Chip
                  label="Plataforma SaaS para gestao premium de quadras"
                  sx={{
                    width: "fit-content",
                    bgcolor: "rgba(124, 232, 255, 0.18)",
                    color: "#DDF8FF",
                    fontWeight: 600,
                    borderRadius: 99,
                  }}
                />

                <Typography
                  variant="h1"
                  sx={{
                    color: "#FFFFFF",
                    fontSize: { xs: "2rem", md: "2.7rem" },
                    lineHeight: 1.1,
                    maxWidth: 640,
                  }}
                >
                  Gestao esportiva inteligente com ritmo de alta performance
                </Typography>

                <Typography
                  sx={{
                    color: "rgba(230,244,255,0.86)",
                    fontSize: { xs: 16, md: 18 },
                  }}
                >
                  O Alttime integra agendamentos, mensalistas, recorrencia e
                  administracao financeira em uma experiencia unica, moderna e
                  escalavel.
                </Typography>

                <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
                  <Button
                    variant="contained"
                    color="primary"
                    href="/register"
                    endIcon={<ArrowRightAltRoundedIcon />}
                  >
                    Iniciar teste gratis
                  </Button>
                  <Button
                    variant="outlined"
                    href="#agenda-ritmo"
                    endIcon={<KeyboardArrowDownRoundedIcon />}
                    sx={(theme) => ({
                      borderColor:
                        theme.palette.mode === "dark"
                          ? "rgba(98, 164, 214, 0.58)"
                          : "rgba(124, 232, 255, 0.55)",
                      color:
                        theme.palette.mode === "dark" ? "#CFE4F8" : "#DDF8FF",
                      "&:hover": {
                        backgroundColor:
                          theme.palette.mode === "dark"
                            ? "rgba(98, 164, 214, 0.16)"
                            : "rgba(124, 232, 255, 0.12)",
                      },
                    })}
                  >
                    Ver experiencia
                  </Button>
                </Stack>

                <Typography
                  variant="body2"
                  sx={{ color: "rgba(220,240,255,0.84)" }}
                >
                  Ja possui conta?{" "}
                  <Link
                    href="/login"
                    sx={{
                      color: "#BCEFFF",
                      textDecoration: "underline",
                      "&:hover": { color: "#FFFFFF" },
                    }}
                  >
                    Entrar na plataforma
                  </Link>
                </Typography>

                <Grid container spacing={1.5}>
                  {heroStats.map((item) => (
                    <Grid item xs={12} sm={4} key={item.label}>
                      <Box
                        sx={(theme) => ({
                          p: 2,
                          borderRadius: 3,
                          bgcolor:
                            theme.palette.mode === "dark"
                              ? "rgba(13, 31, 47, 0.78)"
                              : "rgba(4, 35, 59, 0.66)",
                          border:
                            theme.palette.mode === "dark"
                              ? "1px solid rgba(92, 153, 202, 0.34)"
                              : "1px solid rgba(124, 232, 255, 0.28)",
                        })}
                      >
                        <Typography
                          sx={{
                            color: "#C2F5FF",
                            fontWeight: 700,
                            fontSize: 28,
                          }}
                        >
                          {item.value}
                        </Typography>
                        <Typography
                          sx={{
                            color: "rgba(220,240,255,0.82)",
                            fontSize: 13.5,
                          }}
                        >
                          {item.label}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Stack>
            </Grid>

            <Grid item xs={12} lg={6}>
              <Box
                sx={{
                  animation: "hero-float 6s ease-in-out infinite",
                  "@keyframes hero-float": {
                    "0%": { transform: "translateY(0px)" },
                    "50%": { transform: "translateY(-8px)" },
                    "100%": { transform: "translateY(0px)" },
                  },
                }}
              >
                <LottieShowcase
                  src={lottieSources.hero}
                  minHeight={440}
                  overlay="Movimento esportivo com inteligencia operacional"
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}
